import PromotionActionType from '../actionTypes/PromotionActionType';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case PromotionActionType.DELETE:
      return { ...state, deletePromotion: action.deletePromotion };
    case PromotionActionType.CREATE:
      return { ...state, createdPromotion: action.createdPromotion };
    default:
      return state;
  }
};
